<template>
  <div v-if="shouldRenderConfig && getShowAddToCart" :class="getClassName">
    <button
      type="button"
      class="btn btn-primary"
      :disabled="isDisabled"
      :class="getDisableClass"
      @click="onClickAddToCart"
    >
      {{ $t("Add to Cart") }}
    </button>
  </div>
</template>
<script>
import { useQuantityFieldStore } from "@/stores/modules/quantityField";
import { useImageEditorStore } from "@/stores/modules/imageEditor";
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { mapState, mapActions } from "pinia";
import { callbackService } from "../../helpers/callbackService";
import { usePersonalizeStore } from "@/stores/modules/personalize";
import { useMyAccountStore } from "@/stores/modules/myAccount";
import { useUpdatesStore } from "@/stores/modules/updates";
import { useUrlsStore } from "@/stores/modules/urls";

import axios from "../../axios-auth";
import { i18n } from "../../i18n.js";
import * as R from "ramda";

export default {
  computed: {
    ...mapState(useChangeOptionsStore, [
      "getAddToCartCallbacks",
      "getIsChangeOptionsLoading",
      "getChangeOptionsPostData",
      "getQuantity",
      "getChangeOptionsData",
      "getSelectedOption"
    ]),
    ...mapState(useWebproductStore, [
      "getHasAutomaticConnect",
      "getFilesConnectLoading",
      "getNumberOfActiveUploads",
      "getIsValidForm",
      "getCallChangeOptionPerType",
      "getShowAddToCart",
      "getNumberOfUploads",
      "getIsLfp",
      "getIsUploadPersonalizationFullPage",
      "getProductPartsNamesForUpload",
      "getSelectionId",
      "getStoreCode"
    ]),
    ...mapState(useQuantityFieldStore, ["getQuantityField"]),
    ...mapState(useMyAccountStore, [
      "getIsMyAccount",
      "getMyAccountUploadPath"
    ]),
    ...mapState(useUpdatesStore, ["getAppSelectionId"]),
    isDisabled: function () {
      if (
        this.getIsUploadPersonalizationFullPage &&
        ((!this.showPersonalizationButton && !this.showUploadTable) ||
          this.showAddToCartButton)
      ) {
        return false;
      }
      return this.getNumberOfUploads == 0;
    },
    getDisableClass: function () {
      return this.getIsChangeOptionsLoading ||
        this.getFilesConnectLoading ||
        this.getNumberOfActiveUploads > 0
        ? "disable"
        : "";
    }
  },
  methods: {
    ...mapActions(useImageEditorStore, ["completePersonalization"]),
    ...mapActions(useQuantityFieldStore, ["setQuantityField"]),
    ...mapActions(useChangeOptionsStore, ["setIsChangeOptionsLoading"]),
    ...mapActions(usePersonalizeStore, ["setPersonalizeLoading"]),
    onClickAddToCart: function (event) {
      var valid = this.validate();
      if (!valid) {
        return;
      }
      this.setPersonalizeLoading(true);
      if (this.getAddToCartCallbacks) {
        R.forEach(callback => {
          if (typeof callback === "function") callback(event);
        }, this.getAddToCartCallbacks);
      }

      if (
        this.getIsUploadPersonalizationFullPage &&
        !this.showPersonalizationButton &&
        !this.showUploadTable
      ) {
        this.getProductPartsNamesForUpload.map(pp => {
          this.attachDummyPdf(pp.code);
        });
      }

      var qty = this.getChangeOptionsData.qty;
      if (qty == undefined) {
        // happens for personlization when opened in iframe
        qty = this.getQuantity;
      }
      if (!qty) {
        qty = 1;
        this.setQuantityField(qty);
        return;
      }

      var onCartData = this.getChangeOptionsPostData(false);
      if (!this.getCallChangeOptionPerType) {
        onCartData.qty = qty;
      }
      if (this.getIsLfp) {
        var payload = {
          onCartDataEncoded: btoa(JSON.stringify(onCartData)),
          onCartData: onCartData
        };
        this.completePersonalization(payload);
      } else {
        this.setIsChangeOptionsLoading(true);
        callbackService.sendCallback(
          callbackService.callbacks.onCartSubmitCallback,
          onCartData
        );
      }
    },

    validate: function () {
      return this.getIsValidForm(this);
    },
    attachDummyPdf: function (pp) {
      const formData = new FormData();
      formData.append("id", pp);
      formData.append("deleteOld", 1);
      if (this.getIsMyAccount && this.getMyAccountUploadPath) {
        formData.append("folder_name", this.getMyAccountUploadPath);
      } else {
        formData.append("folder_name", "tmp." + this.getSelectionId);
      }
      if (this.getAppSelectionId) {
        formData.append("selection", this.getSelectionId);
      }
      if (this.getStoreCode) {
        formData.append("store_code", this.getStoreCode);
      }

      formData.append(
        "selected_pages",
        this.getSelectedOption({
          pp: pp,
          option: "pages"
        })
      );
      formData.append(
        "selected_format",
        this.getSelectedOption({
          pp: pp,
          option: "format"
        })
      );
      formData.append(
        "selected_paper",
        this.getSelectedOption({
          pp: pp,
          option: "paper"
        })
      );
      if (i18n.locale) {
        formData.append("lang", i18n.locale);
      }
      formData.append("processDummyPdf", true);
      const urlsStore = useUrlsStore();
      const webproductStore = useWebproductStore();
      axios.instance
        .post(urlsStore.getUrl(axios.apiUpload), formData)
        .then(response => {})
        .catch(error => {
          webproductStore.getSweetAlert({
            text: "Error " + error,
            icon: "error"
          });
        });
    }
  },
  props: ["showPersonalizationButton", "showUploadTable", "showAddToCartButton"]
};
</script>
